<template>
  <div>
    <v-card class="d-flex justify-start px-1 flex-wrap" color="grey lighten-2" elevation="0" rounded="">
      <v-btn
        small
        light
        color="white"
        :to="`${mainRoute(nav.link)}/${nav.link}`"
        :key="key"
        v-for="(nav, key) in areaNav"
        class="text-capitalize my-1"
        :class="[areaNavKeys[areaNavKeys.length - 1] !== key ? 'mr-3' : '']"
      >
        <v-icon left light>{{nav.icon}}</v-icon>
        {{nav.name}}
      </v-btn>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "UrunNavigasyon",
  computed: {
    ...mapState({
      urunAreasNavigation: state =>
        state.panelNavigation.child.products.child.product_options
    }),
    /**
     * @returns {Object}
     */
    areaNavKeys() {
      return Object.keys(this.urunAreasNavigation.child)
    },
    /**
     * @returns {Array}
     */
    areaNav() {
      return this.urunAreasNavigation.child
    }
  },
  methods: {
    mainRoute(nav) {
      let route = this.$route.path.split("/");
      if (route.length <= 4) {
        return route.join("/");
      } else {
        return route.slice(0, route.length - 1).join("/");
      }
    }
  }
};
</script>

<style>
</style>